import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/log',
        name: 'log',
		subheader: languages.log.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "06",
            icon: "container",
        },
        component: PageAll,
		children: [
			{
				path: '/log',
				name: 'log',
				component: resolve => require(['@/pages/log/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.log.title1,
					permCode: "0601",
				},
			}
		]
    },
]
  